import script from "./MasterPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MasterPage.vue?vue&type=script&lang=ts&setup=true"

import "./MasterPage.vue?vue&type=style&index=0&id=082c24e8&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082c24e8"]])

export default __exports__